import { render, staticRenderFns } from "./ChangeOrganizationDefaultDomain.vue?vue&type=template&id=20be6dd2&scoped=true"
import script from "./ChangeOrganizationDefaultDomain.vue?vue&type=script&lang=js"
export * from "./ChangeOrganizationDefaultDomain.vue?vue&type=script&lang=js"
import style0 from "./ChangeOrganizationDefaultDomain.vue?vue&type=style&index=0&id=20be6dd2&prod&lang=scss"
import style1 from "./ChangeOrganizationDefaultDomain.vue?vue&type=style&index=1&id=20be6dd2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20be6dd2",
  null
  
)

export default component.exports